import { defaultLocale } from '@pkg/config/languages';

/**
 * Locale-resolved fields for a `config.seo` document.
 * Callers must pass `$locale`.
 */
export const defaultSeoFields = `
  "siteTitle": siteTitle[language == $locale][0].value,
  "fallbackSiteTitle": siteTitle[language == "${defaultLocale}"][0].value,
  "favicon": favicon.asset,
  titleSeparator,
  siteUrl,
  withSiteTitle,
  "metaTitle": seoSocial.metaTitle[language == $locale][0].value,
  "metaTitleFallback": seoSocial.metaTitle[language == "${defaultLocale}"][0].value,
  "metaDescription": seoSocial.metaDescription[language == $locale][0].value,
  "metaDescriptionFallback": seoSocial.metaDescription[language == "${defaultLocale}"][0].value,
  "mobileAppDescription": seoSocial.mobileAppDescription[language == $locale][0].value,
  "mobileAppDescriptionFallback": seoSocial.mobileAppDescription[language == "${defaultLocale}"][0].value,
  "iosRatingValue": seoSocial.iosRatingValue[language == $locale][0].value,
  "iosRatingCount": seoSocial.iosRatingCount[language == $locale][0].value,
  "androidRatingValue": seoSocial.androidRatingValue[language == $locale][0].value,
  "androidRatingCount": seoSocial.androidRatingCount[language == $locale][0].value,
  "socialImage": seoSocial.socialImage.asset
`;
